import { useDpsRoutes } from "./routes";
import { GetDefaultIndex } from "../../components";
import { useGetDpsCommonInfoQuery } from "../../features/api/dpsApi";

export { useDpsRoutes };

export default GetDefaultIndex({
  title: "سود نقدی",
  query: useGetDpsCommonInfoQuery,
});
